import React, { useState, useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { AppContext } from "../../../context/AppContext";
import {
  FaTachometerAlt,
  FaCalendarCheck,
  FaRobot,
  FaBell,
  FaHeadset,
  FaCommentDots,
  FaCreditCard,
  FaCog,
  FaSignOutAlt,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import "../../../assets/css/patient/patientlayouts/layoutpages/PatientSidebar.css";

// isMobileOpen / onCloseMobile now come from PatientMasterLayout so the
// parent can render a mobile "Menu" button that actually opens this
// sidebar (the sidebar's own collapse-button is hidden on mobile).
const PatientSidebar = ({ isMobileOpen = false, onCloseMobile = () => {} }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { logout } = useContext(AppContext);
  const navigate = useNavigate();

  const toggleSidebar = () => setIsCollapsed(!isCollapsed);

  const handleLogout = () => {
    onCloseMobile();
    logout();
    navigate('/');
  };

  return (
    <>
      {isMobileOpen && (
        <div className="sidebar-overlay" onClick={onCloseMobile}></div>
      )}

      <div className={`patient-sidebar ${isCollapsed ? "collapsed" : ""} ${isMobileOpen ? "mobile-open" : ""}`}>
        <button className="mobile-close-btn" onClick={onCloseMobile}>
          <FaTimes />
        </button>

        <button className="collapse-button" onClick={toggleSidebar}>
          <FaBars />
        </button>

        <nav className="sidebar-menu">

          <NavLink
            to="/patientdashboard"
            end
            className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}
            onClick={onCloseMobile}
          >
            <div className="link-icon"><FaTachometerAlt /></div>
            <span className="link-text">Dashboard</span>
          </NavLink>

          <NavLink
            to="/patientdashboard/myappointments"
            className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}
            onClick={onCloseMobile}
          >
            <div className="link-icon"><FaCalendarCheck /></div>
            <span className="link-text">Appointments</span>
          </NavLink>

          
          <NavLink
            to="/patientdashboard/mynotifications"
            className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}
            onClick={onCloseMobile}
          >
            <div className="link-icon"><FaBell /></div>
            <span className="link-text">Notifications</span>
          </NavLink>

          <div className="sidebar-divider"></div>

          <NavLink
            to="/patientdashboard/supportticket"
            className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}
            onClick={onCloseMobile}
          >
            <div className="link-icon"><FaHeadset /></div>
            <span className="link-text">Support Tickets</span>
          </NavLink>

          <NavLink
            to="/patientdashboard/feedback"
            className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}
            onClick={onCloseMobile}
          >
            <div className="link-icon"><FaCommentDots /></div>
            <span className="link-text">Feedback</span>
          </NavLink>

          <NavLink
            to="/patientdashboard/payment"
            className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}
            onClick={onCloseMobile}
          >
            <div className="link-icon"><FaCreditCard /></div>
            <span className="link-text">Payment</span>
          </NavLink>

          <div className="sidebar-divider"></div>

          <NavLink
            to="/patientdashboard/mysettings"
            className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}
            onClick={onCloseMobile}
          >
            <div className="link-icon"><FaCog /></div>
            <span className="link-text">Settings</span>
          </NavLink>

          {/* <button
            className="sidebar-link logout-link"
            onClick={handleLogout}
            style={{ border: "none", width: "100%", textAlign: "left", background: "transparent", cursor: "pointer" }}
          >
            <div className="link-icon"><FaSignOutAlt /></div>
            <span className="link-text">Logout</span>
          </button> */}

        </nav>
      </div>
    </>
  );
};

export default PatientSidebar;